import { useMemo } from 'react';
import { useApp } from '../react/app';
import { createUiActions, type UiActions } from './ui-actions';

export function useUiActions(): UiActions {
  const app = useApp();
  return useMemo(() => createUiActions(app), [app]);
}
